<template>
<div>
  <v-header :seller="seller"></v-header>
  <div class="tab border-1px">
    <div class="tab-item">
      <!-- <div>商品</div> -->
      <!-- <a v-link="{path: '/goods'}">商品</a> -->
     <router-link to="goods" class="item">{{ $t("product") }}</router-link>
    </div>
    <!-- <div class="tab-item"> 
      <router-link to="ratings" class="item">评论</router-link>
    </div>-->
    <!-- <div class="tab-item">
      <router-link to="myinfolist" class="item">商家</router-link>
     </div>  -->
    <div class="tab-item">
      <router-link to="mymessage" class="item">{{ $t("myinfo") }}</router-link>
     </div>
  </div>
  <keep-alive>
    <!-- <keep-alive> 包裹动态组件时，会缓存不活动的组件实例，而不是销毁它们。
    详见 https://cn.vuejs.org/v2/guide/components.html#keep-alive -->
    <router-view :seller="seller"></router-view>
  </keep-alive>
</div>
</template>

<script>
import header from 'components/header/header.vue'
// import eventbus from 'common/js/eventbus.js'

const ERR_OK = 0

export default {
  data() {
    return {
      state: this.$store.state,
      seller: {
        id: this.$route.query ? '1' : this.$route.query.id || '1'
      }
    }
  },
  created() {
    this.$store.dispatch('addOne')
    // this.$store.commit('addOne')
    this.$store.commit('upgrade')
    this.$store.commit('updateIbnumber', this.$route.query.ibnumber)
    console.log(`更新 ibnumber`, this.$store.state.ibnumber)
    // 取URL参数id, this.$route.query.id . 为空使用1号
    this.$http.get(this.api.getSeller + `?ID=` + this.seller.id + this.$store.state.ibnumber).then((res) => {
      if (res.data.code === ERR_OK) {
        this.seller = Object.assign({}, this.seller, res.data.data[0])
        if (this.$store.state.dev) console.log(`seller0-api`, this.seller)
        this.$store.state.seller = this.seller
        // this.$store.dispatch('saveinfo', this.state)
      }
    })
    // if (this.$store.state.dev) console.log(`this.$i18n.locale`, this.$i18n.locale)
    // if (this.$store.state.dev) console.log(`this.$store.state.i18n`, this.$store.state.i18n)
    // this.$i18n.locale = this.$store.state.i18n
  },
  // mounted() {
  //   eventbus.$on('open_myaddress', item => {
  //     if (this.$store.state.dev) console.log('接收open_myaddress', item)
  //     this.$router.push('mymessage')
  //   })
  // },
  // beforeDestroy () {
  //   eventbus.$off('open_myaddress')
  // },
  components: {
    'v-header': header
  }
}
</script>

<style lang="scss">@import "common/sass/mixin.scss";

.tab {
    display: flex;
    height: 40px;
    width: 100%;
    line-height: 40px;
    // border-bottom: 1px solid rgba(7,17,27,0.1);
    @include border-1px(rgba(7,17,27,0.1));
    .tab-item {
        flex-grow: 1;
        text-align: center;
        & > .item {
            display: block;
            font-size: 14px;
            color: rgb(77,85,93);
            &.active {
                color: rgb(240,20,20);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// App.vue?7a2c5265